import {
  AiOutlineGif as Gif,
  AiOutlineInfo as Info,
  AiOutlineWallet as Wallet,
  AiOutlineSend as Send,
} from 'react-icons/ai';
import { BiImages as Image, BiNews as News } from 'react-icons/bi';
import {
  BsPersonFill as Person,
  BsReply as Reply,
  BsThreeDots as Dots,
  BsThreeDotsVertical as AltOptions,
  BsFillMicFill as Microphone,
  BsFillPinFill as Pin,
} from 'react-icons/bs';
import { CgBlock as Block } from 'react-icons/cg';
import { FaEthereum as Marketplace } from 'react-icons/fa';
import { FiMeh as Indifferent } from 'react-icons/fi';
import { GoMention as Mention } from 'react-icons/go';
import {
  HiOutlineEmojiSad as Sad,
  HiOutlineMenuAlt1 as Menu,
} from 'react-icons/hi';
import {
  IoMdHappy as Happy,
  IoMdArrowRoundBack as Back,
  IoMdCheckmarkCircleOutline as Verified,
} from 'react-icons/io';
import {
  IoLinkOutline as ExternalLink,
  IoLocationOutline as Location,
} from 'react-icons/io5';
import {
  MdModeNight as DarkMode,
  MdOutlineWbSunny as BrightMode,
  MdStars as AltSubscriptions,
  MdOutlineStars as Subscriptions,
  MdOutlineQrCode as QrCode,
  MdOutlinePersonOff as Untrack,
  MdPhotoCamera as Camera,
  MdEmail as Mail,
} from 'react-icons/md';
import {
  RiLockFill as Locked,
  RiLockUnlockFill as Unlocked,
  RiBookmark2Fill as Saved,
  RiBookmark2Line as Save,
  RiBookReadLine as Read,
  RiCalendarEventFill as AltEvents,
  RiCalendarEventLine as Events,
  RiCompassDiscoverFill as AltDiscover,
  RiCompassDiscoverLine as Discover,
  RiEyeCloseLine as Hide,
  RiFlag2Line as Flag,
  RiHeart3Line as Heart,
  RiHome5Fill as AltHome,
  RiHome5Line as Home,
  RiIndeterminateCircleLine as Remove,
  RiLayoutGridFill as AltSpaces,
  RiLayoutGridFill as Spaces,
  RiLogoutBoxRLine as Logout,
  RiNotification3Line as Notifications,
  RiNotification3Fill as AltNotifications,
  RiQuestionLine as Help,
  RiSearchLine as Search,
  RiSettings5Line as Settings,
  RiShareBoxLine as Share,
  RiSpeakerFill as AltReleases,
  RiSpeakerLine as Releases,
  RiTicketLine as Ticket,
  RiTimeLine as Time,
  RiUserSmileLine as Reaction,
  RiVolumeMuteLine as Mute,
} from 'react-icons/ri';
import {
  SiApplemusic as AppleMusic,
  SiSoundcloud as SoundCloud,
  SiSpotify as Spotify,
  SiYoutube as Youtube,
  SiOpenlayers as Collections,
} from 'react-icons/si';
import {
  VscChromeClose as Close,
  VscAdd as Add,
  VscChevronUp as CaretUp,
  VscChevronDown as CaretDown,
} from 'react-icons/vsc';

import { iconColor, iconSize } from '../../theme/text';
import { IconType } from '../../types/icon.type';
import { IconSize, TextColor } from '../../types/text.type';

interface IconProps {
  icon: IconType;
  size?: IconSize;
  color?: TextColor | 'redish' | 'orangish' | 'greenish' | 'blueish';
  effect?: 'redish' | 'orangish' | 'greenish' | 'blueish';
}

const Icon = (props: IconProps) => {
  const { icon, size, color, effect } = props;
  const iconStyle = `${iconSize[size || 'base']} ${
    iconColor[color || 'primary']
  } ${effect && effect}`;

  return (
    <>
      {icon === 'home' && <Home className={iconStyle} />}
      {icon === 'discover' && <Discover className={iconStyle} />}
      {icon === 'spaces' && <Spaces className={iconStyle} />}
      {icon === 'saved' && <Save className={iconStyle} />}
      {icon === 'marketplace' && <Marketplace className={iconStyle} />}
      {icon === 'events' && <Events className={iconStyle} />}
      {icon === 'releases' && <Releases className={iconStyle} />}
      {icon === 'search' && <Search className={iconStyle} />}
      {icon === 'notifications' && <Notifications className={iconStyle} />}
      {icon === 'alt-notifications' && (
        <AltNotifications className={iconStyle} />
      )}
      {icon === 'caret-down' && <CaretDown className={iconStyle} />}
      {icon === 'caret-up' && <CaretUp className={iconStyle} />}
      {icon === 'dots' && <Dots className={iconStyle} />}
      {icon === 'share' && <Share className={iconStyle} />}
      {icon === 'react' && <Reaction className={iconStyle} />}
      {icon === 'dark-mode' && <DarkMode className={iconStyle} />}
      {icon === 'bright-mode' && <BrightMode className={iconStyle} />}
      {icon === 'close' && <Close className={iconStyle} />}
      {icon === 'alt-home' && <AltHome className={iconStyle} />}
      {icon === 'alt-spaces' && <AltSpaces className={iconStyle} />}
      {icon === 'alt-saved' && <Saved className={iconStyle} />}
      {icon === 'alt-events' && <AltEvents className={iconStyle} />}
      {icon === 'alt-releases' && <AltReleases className={iconStyle} />}
      {icon === 'alt-discover' && <AltDiscover className={iconStyle} />}
      {icon === 'verified' && <Verified className={iconStyle} />}
      {icon === 'image' && <Image className={iconStyle} />}
      {icon === 'gif' && <Gif className={iconStyle} />}
      {icon === 'send' && <Send className={iconStyle} />}
      {icon === 'alt-options' && <AltOptions className={iconStyle} />}
      {icon === 'info' && <Info className={iconStyle} />}
      {icon === 'person' && <Person className={iconStyle} />}
      {icon === 'external-link' && <ExternalLink className={iconStyle} />}
      {icon === 'reply' && <Reply className={iconStyle} />}
      {icon === 'flag' && <Flag className={iconStyle} />}
      {icon === 'remove' && <Remove className={iconStyle} />}
      {icon === 'block' && <Block className={iconStyle} />}
      {icon === 'hide' && <Hide className={iconStyle} />}
      {icon === 'mute' && <Mute className={iconStyle} />}
      {icon === 'sad' && <Sad className={iconStyle} />}
      {icon === 'logout' && <Logout className={iconStyle} />}
      {icon === 'settings' && <Settings className={iconStyle} />}
      {icon === 'help' && <Help className={iconStyle} />}
      {icon === 'read' && <Read className={iconStyle} />}
      {icon === 'like' && <Heart className={iconStyle} />}
      {icon === 'excited' && <Happy className={iconStyle} />}
      {icon === 'indifferent' && <Indifferent className={iconStyle} />}
      {icon === 'ticket' && <Ticket className={iconStyle} />}
      {icon === 'time' && <Time className={iconStyle} />}
      {icon === 'location' && <Location className={iconStyle} />}
      {icon === 'spotify' && <Spotify className={iconStyle} />}
      {icon === 'apple-music' && <AppleMusic className={iconStyle} />}
      {icon === 'soundcloud' && <SoundCloud className={iconStyle} />}
      {icon === 'youtube' && <Youtube className={iconStyle} />}
      {icon === 'menu' && <Menu className={iconStyle} />}
      {icon === 'wallet' && <Wallet className={iconStyle} />}
      {icon === 'news' && <News className={iconStyle} />}
      {icon === 'collections' && <Collections className={iconStyle} />}
      {icon === 'subscriptions' && <Subscriptions className={iconStyle} />}
      {icon === 'alt-subscriptions' && (
        <AltSubscriptions className={iconStyle} />
      )}
      {icon === 'qrcode' && <QrCode className={iconStyle} />}
      {icon === 'mic' && <Microphone className={iconStyle} />}
      {icon === 'untrack' && <Untrack className={iconStyle} />}
      {icon === 'pin' && <Pin className={iconStyle} />}
      {icon === 'back' && <Back className={iconStyle} />}
      {icon === 'locked' && <Locked className={iconStyle} />}
      {icon === 'unlocked' && <Unlocked className={iconStyle} />}
      {icon === 'add' && <Add className={iconStyle} />}
      {icon === 'camera' && <Camera className={iconStyle} />}
      {icon === 'mention' && <Mention className={iconStyle} />}
      {icon === 'mail' && <Mail className={iconStyle} />}
    </>
  );
};

export default Icon;
